import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __ANPR_PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface NotCertifiableAnprListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (notCertifiableAnpr?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface NotCertifiableAnpr {
  key: Key;
  descrizione: string;
}

const NotCertifiableAnprListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Non certificabilità ANPR',
  id = 'notCertifiableAnpr',
}: NotCertifiableAnprListComponentProps): React.ReactElement => {
  const [notCertifiableAnpr] = useHttpFetch<
    HttpResponseListPayloadQuarkus<NotCertifiableAnpr>,
    Array<ItemVM>
  >(`${__ANPR_PERSON_NEW_API_URL__}/non-certificabilita`, {
    onBootstrap: true,
    initialData: [],
    transformer: (response: AxiosResponse<HttpResponseListPayloadQuarkus<NotCertifiableAnpr>>) => {
      const { data } = response;

      return data?.payload?.map((item) => ({
        id: item.key.codice?.toString(),
        value: item.descrizione,
      })) as Array<ItemVM>;
    },
  });

  const list = (notCertifiableAnpr.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

NotCertifiableAnprListComponent.displayName = 'Not Certifiable Anpr List component';

const NotCertifiableAnprList = memo(NotCertifiableAnprListComponent);

export default NotCertifiableAnprList as typeof NotCertifiableAnprListComponent;
